module.exports = __webpack_public_path__ + "static/media/upload_attach.3e02f267.svg";